import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import CloseIcon from "@mui/icons-material/Close";
import { EsimPlan } from "../../pages/MyEsimPage";

function ModalOrderDetail({
  open,
  plan,
  onClose,
}: {
  open: boolean;
  plan: Omit<EsimPlan, "status" | "expiresAt"> | null;
  onClose: () => void;
}) {
  const isSmall = useMediaQuery("(max-width:600px)");
  console.log(plan);
  const getQrSrc = (qr: string) => {
    if (!qr) return "";
    if (qr.startsWith("data:image")) return qr; // already data URL
    if (/^https?:\/\//i.test(qr)) return qr; // plain URL
    return `data:image/png;base64,${qr}`; // raw base64 → data URL
  };

  const handleDownloadQr = async () => {
    if (!plan) return;
    const src = getQrSrc(plan.qrData);
    if (!src) return;

    try {
      const res = await fetch(src, { mode: "cors" as RequestMode });
      const blob = await res.blob(); // image/png
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `${plan.msisdn}-esim-qr.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch {
      // CORS or fetch blocked? open the source in a new tab as a fallback.
      window.open(src, "_blank");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pr: 6 }}>
        {plan ? plan.planName : "eSIM Details"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {plan && (
          <Stack spacing={2} alignItems="center">
            <Box
              sx={{
                width: 180,
                height: 180,
                overflow: "hidden",
                border: (t) => `1px solid ${t.palette.divider}`,
                bgcolor: "#fff",
              }}
            >
              <img
                src={getQrSrc(plan.qrData)}
                alt="eSIM QR Code"
                style={{
                  display: "block",
                  width: 180,
                  height: 180,
                  objectFit: "contain",
                }}
              />
            </Box>

            <Stack spacing={0.25} alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Scan to install this eSIM
              </Typography>
              <Typography variant="caption" color="text.disabled">
                MSISDN / IMSI: {plan.msisdn}
              </Typography>
            </Stack>

            <Divider flexItem sx={{ width: "100%", my: 0.5 }} />

            <Stack
              direction={isSmall ? "column" : "row"}
              spacing={1.25}
              sx={{ width: "100%" }}
            >
              <Button
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                startIcon={<SimCardDownloadIcon />}
                onClick={handleDownloadQr}
              >
                Download QR (PNG)
              </Button>
              {/* If you bring back a guide:
              <Button fullWidth size="large" variant="outlined" color="primary" href={plan.guideUrl}>
                View Guide
              </Button>
              */}
            </Stack>
          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default ModalOrderDetail;
